import { createContext } from "react";

const ordersContext = createContext();

export default ordersContext;
